(function($, exports) {

	function toggleListener() {
		var $toggle = $('.l-footer__top').find('h6');

		$toggle.on('click', function() {

			$(this).toggleClass('is-open');
			$(this).next('.l-footer__container').slideToggle();
		});

	}


	exports.init = function() {
		
		if($(window).width() < 767) {
			toggleListener();
		}

	};
	
})(jQuery, this.FOOTER = {});